import React from 'react';
import NewsletterManagementComponent from '../../../components/admin/newsletter/NewsletterManagementComponent';

const NewsletterManagement: React.FC = () => {
  return <NewsletterManagementComponent />;
};

export default NewsletterManagement;
